<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-lg-6">
          <h1 class="text-white pt-3 px-3">รายงานแสดงรายละเอียดสาขาทั้งหมด</h1>
          <p
            class="text-white pb-0 px-3"
          >แสดงข้อมูลสถานะแต่ละสาขา สามารถเปิดปิดการใช้งาน แก้ไข และลบข้อมูลแต่ละสาขาได้</p>
        </div>
        <div class="col-12 col-lg-6 align-self-center text-right">
          <h1 class="display-3 text-white">
            <small>ยอดคงค้างทั้งหมด :</small>
            0.00
            <small>บาท</small>
          </h1>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row">
                <div class="col">
                  <div class="row justify-content-between">
                    <div class="col-12 col-md-6 col-xl-4 mb-3">
                      <b-form-group
                        id="input-group-1"
                        label="ค้นหาข้อมูล"
                        label-for="input-1"
                        class="mb-0"
                      >
                        
                            <b-form-input
                              id="input-1"
                              type="text"
                              required
                            ></b-form-input>
                        
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-6 col-xl-2">
                      <b-form-group label="Export File" class="mb-0 pb-2">
                        <div class="btn-group btn-sm-res" role="group" aria-label="Basic example">
                          <download-excel
                          :data="tableData"
                          worksheet="sheet1"
                          name="ReportPos.xls"
                          class="btn-ex btn-sm-res"
                        >
                          <b-button variant="success" class="btn-sm-res">excel</b-button>
                        </download-excel>
                          <b-button variant="info" class="btn-sm-res" @click="$htmlToPaper('tablePrint')" >print</b-button>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div id="tablePrint" class="table-responsive">
                <base-table thead-classes="thead-light" :data="tableData">
                  <template slot="columns">
                    <th>#</th>
                    <th>ชื่อสาขา</th>
                    <th>ชื่อเจ้าของ</th>
                    <th>เบอร์โทรศัพท์</th>
                    <th>สถานะ</th>
                    <th>ยอดคงค้าง</th>
                  </template>

                  <template slot-scope="{row}">
                    <th scope="row">{{row.no}}</th>
                    <td>{{row.page}}</td>
                    <td>{{row.visitors}}</td>
                    <td>{{row.unique}}</td>
                    <td>
                      <b-form-checkbox v-model="checked" name="check-button" switch></b-form-checkbox>
                    </td>
                    <td>{{row.bounceRate}}</td>
                  </template>
                </base-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
        {
          no: "1",
          page: "One",
          visitors: "โอ",
          unique: "0820444444",
          bounceRate: "0.00"
        }
      ]
    };
  }
};
</script>

<style></style>
